import React from 'react';
import {
  addPathToList,
  allow_full_access, Android,
  come_back_icon_ios,
  enable_the_keyboard,
  file_type_icon, success_icon,
  success_open_keyboard_with_interaction,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';

//= ========================================================================
const Panel_V03_instructions = ({
  globJSON,
  selectedScreen,
  simPlatform,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const AndroidEditTextList = [
    'o_i_step_1_of_2',
    'o_i_step_2_of_2',
    'o_i_enable_bank_keyboard_and',
    'o_i_switch_to_bank_keyboard_and',
    'o_i_your_privacy_title',
    'o_i_your_privacy',
    'o_i_take_me_there',
    'maybe_later',
    'o_i_lets_do_it',
    'success',
    'o_done',
    'o_i_give_it_a_go',
    'o_i_tap_the_bank_icon',
    'bank_keyboard',
    'onboarding_titleBar',
    'select_keyboard',
    'other_keyboards',
  ];
  const IOSEditTextList = [
    'o_i_step_1_of_2',
    'o_i_enable_bank_keyboard',
    'o_i_goto_settings',
    'o_i_tap_keyboards',
    'o_i_enable_keyboard',
    'o_i_come_back_here',
    'o_i_your_privacy_title',
    'o_i_your_privacy',
    'o_i_take_me_there',
    'o_i_nanother_time',
    'o_i_step_2_of_2',
    'o_i_switch_to_bank_keyboard',
    'o_i_touch_and_hold',
    'success',
    'o_done',
    'o_i_give_it_a_go',
    'o_i_tap_the_bank_icon',
    'bank_keyboard',
    'keyboard_button',
    'other_keyboards',
  ];

  const listObject = [
    {
      subHeadline: come_back_icon_ios,
      fileId: 'configurations/onboarding/instructions/kbd_come_back_icon',
    }, {
      subHeadline: success_icon,
      fileId: 'configurations/onboarding/instructions/kbd_success_icon',
    },
  ];

  const { instructions } = globJSON.configurations.onboarding;

  const onValueChanged = (key, value) => {
    instructions[key] = value;
    onConfigChanged();
  };
  const { enable_keyboard_with_string } = instructions;
  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={enable_the_keyboard}
      paragraph={allow_full_access}
      editTextList={addPathToList(simPlatform === Android ? AndroidEditTextList : IOSEditTextList, 'configurations/onboarding/instructions/')}
      tooltipsTitles={globJSON.configurations.onboarding.screens_ordering}
      language={language}
      paddingVertical={25}
      isHollow
    >
      <SwitcherPanel
        text={success_open_keyboard_with_interaction}
        value={enable_keyboard_with_string}
        onValueChanged={(value) => {
          onValueChanged('enable_keyboard_with_string', value);
        }}
        marginBottom={22}
      />
      <BreakLine />
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Upload_assets}
        details={file_type_icon}
        listObject={listObject}
        TwoButtonsInARow
      />
    </FullPagePanel>
  );
};

export default Panel_V03_instructions;
